module.exports = __webpack_public_path__ + "static/img/new_home_4.65c5e1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_new/new_home_4.jpg
// module id = eiJ3
// module chunks = 6